import { Controller } from "@hotwired/stimulus";

// Progress Accordion Controller - Manages collapsible progress and status sections
export default class extends Controller {
  static targets = ["content", "trigger", "icon"];
  static values = {
    expanded: Boolean
  };

  connect() {
    // Start collapsed by default
    this.expandedValue = false;
    this.updateDisplay(false);
  }

  toggle(event) {
    event.preventDefault();
    this.expandedValue = !this.expandedValue;
    this.updateDisplay(true);
  }

  updateDisplay(animate = true) {
    if (this.expandedValue) {
      this.expandContent(animate);
    } else {
      this.collapseContent(animate);
    }
    this.updateTrigger();
  }

  expandContent(animate = true) {
    if (!this.hasContentTarget) return;

    if (animate) {
      // Set initial state for animation
      this.contentTarget.classList.remove("hidden");
      this.contentTarget.style.height = "0px";
      this.contentTarget.style.opacity = "0";
      this.contentTarget.style.overflow = "hidden";

      // Force reflow to ensure styles are applied
      requestAnimationFrame(() => {
        // Get the natural height
        const naturalHeight = this.contentTarget.scrollHeight;

        // Animate to full height
        this.contentTarget.style.transition = "height 300ms ease-in-out, opacity 300ms ease-in-out";
        this.contentTarget.style.height = naturalHeight + "px";
        this.contentTarget.style.opacity = "1";

        // Clean up after animation
        setTimeout(() => {
          this.contentTarget.style.height = "auto";
          this.contentTarget.style.transition = "";
          this.contentTarget.style.overflow = "";
        }, 300);
      });
    } else {
      this.contentTarget.classList.remove("hidden");
      this.contentTarget.style.height = "auto";
      this.contentTarget.style.opacity = "1";
    }
  }

  collapseContent(animate = true) {
    if (!this.hasContentTarget) return;

    if (animate && !this.contentTarget.classList.contains("hidden")) {
      // Set up for animation
      this.contentTarget.style.height = this.contentTarget.scrollHeight + "px";
      this.contentTarget.style.transition = "height 300ms ease-in-out, opacity 300ms ease-in-out";

      // Force reflow
      this.contentTarget.offsetHeight;

      // Animate to collapsed state
      this.contentTarget.style.height = "0px";
      this.contentTarget.style.opacity = "0";

      // Hide after animation
      setTimeout(() => {
        this.contentTarget.classList.add("hidden");
        this.contentTarget.style.transition = "";
        this.contentTarget.style.height = "";
        this.contentTarget.style.opacity = "";
      }, 300);
    } else {
      this.contentTarget.classList.add("hidden");
      this.contentTarget.style.height = "";
      this.contentTarget.style.opacity = "";
    }
  }

  updateTrigger() {
    if (this.hasTriggerTarget) {
      this.triggerTarget.setAttribute("aria-expanded", this.expandedValue.toString());
    }

    // Rotate chevron icon
    if (this.hasIconTarget) {
      if (this.expandedValue) {
        this.iconTarget.style.transform = "rotate(180deg)";
      } else {
        this.iconTarget.style.transform = "rotate(0deg)";
      }
    }
  }
}